import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';
import * as Headers from 'ui-library/Headers';

interface FormInstanceHeaderProps {
  name: string;
  disableSubmit: boolean;
  hideSubmit: boolean;
  onSubmit?: () => void;
}

export default function FormInstanceHeader({
  name,
  disableSubmit,
  hideSubmit,
  onSubmit,
}: FormInstanceHeaderProps): JSX.Element {
  return (
    <div className={css(styles.headerWrapper)}>
      <Headers.Header1 className={css(styles.header)}>{name}</Headers.Header1>
      {!hideSubmit && (
        <Button
          buttonStyle={ButtonStyle.SECONDARY}
          size={ButtonSize.MEDIUM}
          disabled={disableSubmit}
          onClick={onSubmit}
          text="Submit"
        />
      )}
    </div>
  );
}

const styles = StyleSheet.create({
  headerWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  header: {
    fontSize: '22px',
  },
});
